module.exports = __webpack_public_path__ + "static/media/app_store_qr.647228ae.png";